'use client'
import React, { ReactNode, useState } from "react"
import styles from "./Faqs.module.css"
import faqConfig from "@/app/[locale]/why-choose-us/Faqs/faqs.json"
import { useTranslations } from "use-intl"
import Icon from "@/components/UI/Icon/Icon"
import IconArrowDown from "@/assets/img/Icon_ChevronDown.svg"
import IconArrowUp from "@/assets/img/Icon_ChevronUp.svg"
import AppLink from "@/components/UI/Links/AppLink/AppLink"

interface FaqItem {
  title: string
  text: string
}

export default function Faqs() {
  const t = useTranslations("FrontPage.Faqs")

  // Dynamic map of destinations
  // It can come from config, CMS, database, etc.
  const linkMap: Record<string, string> = {
    docs: "/docs",
    blog: "/blog",
    pricing: "/pricing",
    guide: "/guide",
    support: "https://support.example.com"
  }

  const buildRichComponents = () => {
    const components: Record<string, (chunks: ReactNode) => ReactNode> = {
      strong: (chunks) => (
        <span className={styles.highlight}>
          {chunks}
        </span>
      ),
      ul: (chunks) => (
        <ul className={styles.list}>
          {chunks}
        </ul>
      ),
      li: (chunks) => (
        <li className={styles.listItem}>
          {chunks}
        </li>
      )
    }

    Object.entries(linkMap).forEach(([tag, href]) => {
      components[tag] = (chunks: ReactNode) => {
        return <AppLink href={href}>{chunks}</AppLink>
      }
    })

    return components
  }

  const richComponents = buildRichComponents();

  const [openIndexes, setOpenIndexes] = useState<number[]>([])

  function toggleOpen(idx: number) {
    setOpenIndexes(prev => {
        if(prev.includes(idx)) return prev.filter(i => i !== idx)
        else return [...prev, idx]
    })
  }

  return (
    <section id={'faqs'} className={styles.main} data-scroll-section>
      <h2 className="title1">{t('title')}</h2>
      <div className={styles.container}>
      {faqConfig.map((item: FaqItem, idx: number) => (
        <div key={idx} className={`${styles.faq} largeButton ${openIndexes.includes(idx) ? styles.open: ''}`} onClick={() => toggleOpen(idx)}>
            <div className={styles.question}>
              <div>
                {t(item.title)}
              </div>
              {openIndexes.includes(idx) && <Icon icon={IconArrowUp} className={styles.arrow}/>}
              {!openIndexes.includes(idx) && <Icon icon={IconArrowDown} className={styles.arrow}/>}
            </div>
            <div className={styles.answer}>
              <div className={'bodyTextMedium'}>
                {t.rich(item.text, richComponents)}
              </div>
            </div>
        </div>
      ))}
      </div>
    </section>
  )
}